/** Parses a MenuBar: Control plus `flat`, its one property that changes what draws. */
import { parseControl } from '../control/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseMenuBar(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.flat = boolSlotValue(properties.flat) === true;
    return result;
}
//# sourceMappingURL=parser.js.map